export const hr = {
  firstDayOfWeek: 1,
  accept: 'Da',
  reject: 'Ne',
  dayNames: [
    'Nedjelja',
    'Ponedjeljak',
    'Utorak',
    'Srijeda',
    'Četvrtak',
    'Petak',
    'Subota',
  ],
  dayNamesMin: ['Ne', 'Po', 'Ut', 'Sr', 'Če', 'Pe', 'Su'],
  dayNamesShort: ['Ne', 'Po', 'Ut', 'Sr', 'Če', 'Pe', 'Su'],
  monthNames: [
    'Siječanj',
    'Veljača',
    'Ožujak',
    'Travanj',
    'Maj',
    'Lipanj',
    'Srpanj',
    'Kolovoz',
    'Rujan',
    'Listopad',
    'Studeni',
    'Prosinac',
  ],
  monthNamesShort: [
    'Sij',
    'Vel',
    'Mar',
    'Trav',
    'Maj',
    'Lip',
    'Sr',
    'Kol',
    'Ruj',
    'Lis',
    'Stu',
    'Pro',
  ],
  today: 'Danas',
  clear: 'Očisti',
  upload: 'Prenesi',
  filter: 'Filter',
  equals: 'je jednak',
  notEquals: 'nije jednak',
  contains: 'sadrži',
  notContains: 'ne sadrži',
  startsWith: 'počinje sa',
  endsWith: 'završava sa',
  noFilter: 'Nema filtera',
  filterEmpty: 'Nema filtera',
  filterClear: 'Očisti filter',
  lt: 'je manje od',
  gt: 'je više od',
  lte: 'je manje ili jednako',
  gte: 'je više ili jednako',
  dateIs: 'je na',
  dateIsNot: 'nije na',
  dateBefore: 'je prije',
  dateAfter: 'je poslije',
  emptyFilterMessage: 'Nema rezultata',
  dateFormat: 'dd.mm.yy',
  choose: 'Odaberi',
  cancel: 'Abbrechen',
  apply: 'Primijeni',
  selectionMessage: '{0} odabrano',
};
